
const l10n: { [key in ShareOptionLangCode]: { btnShare: string, successMsg: string, btnClose: string } } = {
    ko: {
        btnShare: '공유',
        btnClose: '닫기',
        successMsg: '주소가 복사되었습니다. 원하는 곳에 붙여넣기 해주세요.',
    },
    en: {
        btnShare: 'Share',
        btnClose: 'Close',
        successMsg: 'URL copied. You can now paste it anywhere you want.',
    },
    ar: {
        btnShare: 'مشاركة',
        btnClose: 'إغلاق',
        successMsg: 'تم نسخ العنوان. الرجاء لصقه في المكان الذي تريده.',
    },
    zh: {
        btnShare: '分享',
        btnClose: 'Close',
        successMsg: '已複製連結，分享給好友吧',
    },
    id: {
        btnShare: 'Bagikan',
        btnClose: 'Tutup',
        successMsg: 'URL telah disalin. Silakan gunakan URL dengan menempatkannya di tempat yang Anda inginkan.',
    },
    ja: {
        btnShare: '共有',
        btnClose: '閉じる',
        successMsg: 'アドレスがコピーされました。',
    },
    ru: {
        btnShare: 'Поделиться',
        btnClose: 'Закрыть',
        successMsg: 'Ссылка скопирована. Вы можете использовать ее в нужном месте.',
    },
    th: {
        btnShare: 'แชร์',
        btnClose: 'ปิด',
        successMsg: 'คัดลอก URL สำเร็จ กรุณาวางในที่ที่ต้องการ',
    },
    de: {
        btnShare: 'Teilen',
        btnClose: 'Schließen',
        successMsg: 'URL wurde kopiert. Sie können sie nun an der gewünschten Stelle einfügen.',
    },
    fr: {
        btnShare: 'Partager',
        btnClose: 'Fermer',
        successMsg: 'L\'URL a été copiée. Vous pouvez à présent la coller où vous voulez.',
    },
    it: {
        btnShare: 'Condividi',
        btnClose: 'Chiudi',
        successMsg: 'URL copiato. Ora puoi incollarlo dove vuoi.',
    },
    es_ES: {
        btnShare: 'Compartir',
        btnClose: 'Cerrar',
        successMsg: 'Enlace copiado. Ahora puedes pegarlo donde quieras.',
    },
    es_MX: {
        btnShare: 'Compartir',
        btnClose: 'Cerrar',
        successMsg: 'Se copió la dirección URL. Ahora puedes pegarla donde quieras.',
    },
    pt: {
        btnShare: 'Compartilhar',
        btnClose: 'Fechar',
        successMsg: 'URL copiado. Você pode colar onde quiser.',
    },
    tr: {
        btnShare: 'Paylaş',
        btnClose: 'Kapat',
        successMsg: 'URL kopyalandı. Artık istediğiniz yere yapıştırabilirsiniz.',
    },
    vi:{
        btnShare: 'Chia sẻ',
        btnClose: 'Đóng',
        successMsg: 'Chia sẻ bài viết trên mạng xã hội.',
    },

};

export default l10n;
